import JourneyEventBuffer from "./JourneyEventBuffer";

/**
 * Centralized feature use tracking for journey events.
 * Never throws – failures are silenced so tracking cannot break app flow.
 */
export function trackFeatureUse(feature, extraData = {}) {
  if (!feature) return;
  try {
    JourneyEventBuffer.track("feature_use", {
      event_data: { feature, ...extraData },
    });
  } catch (e) {
    // Never break the app for tracking
  }
}
